export enum WizardStep {
  OCCASION = 'occasion',
  GREET = 'greet',
  PERSONAL_GREET = 'personal-greet',
  PREVIEW = 'preview',
}
